import { Store } from 'store';
import { CustomerDeviceType } from '../types';

const isMobile = (store: Store) =>
  [CustomerDeviceType.MOBILE, CustomerDeviceType.TABLET].indexOf(store.app.customerDeviceType) > -1;

export default isMobile;
